export default __webpack_public_path__ + "static/media/the_emperor.34f5e195.png";